module.exports = __webpack_public_path__ + "static/media/logo.aa710516.svg";